export class AjaxScroll {
    constructor()
    {
        document.querySelectorAll('*[ajax-scroll]').forEach(container => {

            let trigger = document.querySelector('.ajax-trigger');
            let currentPage = parseInt(container.getAttribute('ajax-scroll-page'))
            const loaderContainer = document.createElement('div')
            loaderContainer.classList.add('loader-container')

            const loader = document.createElement('div')
            loader.classList.add('loader')
            loaderContainer.append(loader)

            let observer = new IntersectionObserver(
                (entries, observer) => {
                    if (entries[0].isIntersecting) {

                        if (!container.classList.contains('is-loading')) {
                            container.classList.add('is-loading')
                            container.append(loaderContainer)
                        }

                        currentPage++
                        container.classList.add('is-loading')

                        fetch(`?paged=${currentPage}`)
                            .then(r => r.text())
                            .then(html => {
                                const parser = new DOMParser();
                                const htmlDocument = parser.parseFromString(html, "text/html");
                                container.classList.remove('is-loading')
                                container.append(...htmlDocument.querySelector('*[ajax-scroll]').children)
                                loaderContainer.remove()
                            })
                            .catch(function(error) {
                                container.classList.remove('is-loading')
                                loaderContainer.remove()
                                observer.unobserve(entries[0].target);
                            })


                        // observer.unobserve(entries[0].target);
                    }
                }, {
                    root: null,
                    rootMargin: '0px 0px 0px 0px',
                    threshold: 0.01,
                }
            );

            observer.observe(trigger);
        })
    }
}
